// SEO 메타 태그 설정
export const seoConfig = {
  default: {
    title: "DevKids with VibeAZ - 어린이와 비전공자를 위한 코딩 교육",
    description: "AI 시대에 꼭 필요한 프로그래밍 기초! Python, HTML, CSS로 시작하는 재미있는 코딩 학습. VibeAZ와 함께 만드는 바이브 코딩 앱으로 누구나 쉽게 배워요.",
    keywords: "어린이 코딩, 비전공자 프로그래밍, AI 코딩 교육, Python 학습, HTML CSS 기초, VibeAZ, 바이브 코딩, 초등 코딩 교육",
    ogImage: "/images/noimage.png",
    ogUrl: "https://www.devkids.co.kr/",
  },
  courses: {
    title: "코스 목록 - DevKids with VibeAZ",
    description: "Python, HTML, CSS로 시작하는 재미있는 코딩 학습 코스들을 확인하세요. 축구 카드 만들기 등 다양한 프로젝트로 프로그래밍을 배워보세요.",
    keywords: "코딩 코스, 프로그래밍 학습, Python 프로젝트, HTML CSS 실습, 어린이 코딩 교육",
    ogUrl: "https://www.devkids.co.kr/courses",
  },
  onboarding: {
    title: "시작하기 - DevKids with VibeAZ",
    description: "DevKids와 함께 코딩 학습을 시작해보세요. 이름과 나이를 입력하고 맞춤형 학습을 경험하세요.",
    ogUrl: "https://www.devkids.co.kr/onboarding",
  },
  courseDetail: {
    "soccer-card-making": {
      title: "축구 카드 만들기 - Python으로 만드는 나만의 축구 스타 | DevKids",
      description: "Python, HTML, CSS로 손흥민 같은 축구 선수의 카드를 직접 만들어보세요! 변수, 타입, 조건문을 재미있게 배우며 프로그래밍의 기초를 익힙니다.",
      keywords: "축구 카드 만들기, Python 코딩, 어린이 프로그래밍, 손흥민 카드, HTML CSS 실습, 코딩 교육, DevKids",
      ogImage: "/courses/soccer-card-making/soccer-card-preview.png",
      ogUrl: "https://www.devkids.co.kr/course/soccer-card-making",
    }
  }
};

// 동적으로 메타 태그 업데이트하는 함수
export const updateMetaTags = (config) => {
  // title
  document.title = config.title || seoConfig.default.title;
  
  // meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = config.description || seoConfig.default.description;
  
  // meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.content = config.keywords || seoConfig.default.keywords;
  
  // Open Graph
  updateOGTag('og:title', config.title || seoConfig.default.title);
  updateOGTag('og:description', config.description || seoConfig.default.description);
  updateOGTag('og:image', config.ogImage || seoConfig.default.ogImage);
  updateOGTag('og:url', config.ogUrl || seoConfig.default.ogUrl);
  
  // Twitter Card
  updateOGTag('twitter:title', config.title || seoConfig.default.title);
  updateOGTag('twitter:description', config.description || seoConfig.default.description);
  updateOGTag('twitter:image', config.ogImage || seoConfig.default.ogImage);
};

// Open Graph 태그 업데이트 헬퍼 함수
const updateOGTag = (property, content) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.content = content;
};